import React, { useState } from 'react';
import './PasswordGenerator.css';

const PasswordGenerator = () => {
  const [password, setPassword] = useState('');
  const [length, setLength] = useState(8);
  const [hasUpper, setHasUpper] = useState(false);
  const [hasLower, setHasLower] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSymbol, setHasSymbol] = useState(false);

  const randomFunc = {
    lower: () => String.fromCharCode(Math.floor(Math.random() * 26) + 97),
    upper: () => String.fromCharCode(Math.floor(Math.random() * 26) + 65),
    number: () => String.fromCharCode(Math.floor(Math.random() * 10) + 48),
    symbol: () => '!@#$%^&*(){}[]=<>/,.'[Math.floor(Math.random() * 20)],
  };

  // eslint-disable-next-line
  const generatePassword = () => {
    const typesCount = hasLower + hasUpper + hasNumber + hasSymbol;
    if (typesCount === 0) return '';

    const typesArr = [
      { lower: hasLower },
      { upper: hasUpper },
      { number: hasNumber },
      { symbol: hasSymbol },
    ].filter((item) => Object.values(item)[0]);
    
    let tempPassword = ''; // Use a local variable to build the password
    // eslint-disable-next-line
    for (let i = 0; i < length; i += typesCount) {
      // eslint-disable-next-line
      typesArr.forEach((type) => {
        const funcName = Object.keys(type)[0];
        tempPassword += randomFunc[funcName]();
      });
    }

    setPassword(tempPassword.slice(0, length)); // Update state after the loop
};

  const copyToClipboard = () => {
    if (!password) return;
    navigator.clipboard.writeText(password);
    alert('Password copied to clipboard');
  };

  return (
    <div className="container">
      <h2>Password Generator</h2>
      <div className="result-container">
        <span id="result">{password}</span>
        <button className="btn" onClick={copyToClipboard}>
          Copy
        </button>
      </div>
      <div className="setting">
        <label>Password Length</label>
        <input
          type="number"
          id="length"
          value={length}
          onChange={(e) => setLength(+e.target.value)}
          min="4"
          max="20"
        />
      </div>
      <div className="setting">
        <label>Include Uppercase</label>
        <input
          type="checkbox"
          id="uppercase"
          checked={hasUpper}
          onChange={(e) => setHasUpper(e.target.checked)}
        />
      </div>
      <div className="setting">
        <label>Include Lowercase</label>
        <input
          type="checkbox"
          id="lowercase"
          checked={hasLower}
          onChange={(e) => setHasLower(e.target.checked)}
        />
      </div>
      <div className="setting">
        <label>Include Numbers</label>
        <input
          type="checkbox"
          id="numbers"
          checked={hasNumber}
          onChange={(e) => setHasNumber(e.target.checked)}
        />
      </div>
      <div className="setting">
        <label>Include Symbols</label>
        <input
          type="checkbox"
          id="symbols"
          checked={hasSymbol}
          onChange={(e) => setHasSymbol(e.target.checked)}
        />
      </div>
      <button className="btn btn-large" onClick={generatePassword}>
        Generate Password
      </button>
    </div>
  );
};

export default PasswordGenerator;
